import { styled } from 'stitches.config'

export const NonCollapsibleMenuRoot = styled('div', {
  paddingTop: '$2',
  overflow: 'auto',
  backgroundColor: '$accent-white',
  padding: '$2',
  borderRadius: '$4',
  border: '1px solid $secondary-600',
  color: '$tertiary-900',
  width: '100%',
  '& li > a': {
    // color: '$tertiary-900',
  },

  '@bp2': {
    display: 'none',
  },

  variants: {
    active: {
      true: {
        backgroundColor: '$secondary-200',
      },
    },
  },
})

export const LinkItem = styled('li', {
  border: '1px solid transparent',
  textAlign: 'center',
  padding: '$1 0',
  borderRadius: '8px',
  variants: {
    active: {
      true: {
        backgroundColor: '$primary-800',
        color: '$accent-white !important',
        borderRadius: '8px',
      },
      false: {
        border: '1px solid $primary-800',
        color: '$tertiary-900',
        '&:hover': {
          backgroundColor: '$accent-white',
        },
      },
    },
  },
  '&:hover': {
    cursor: 'pointer',
  },
})
